import { displayMessage } from "../../helpers/messages";
import dayjs from 'dayjs';

export default [
    {
        field: 'id',
        headerName: 'Código',
        width: 80
    },
    {
        field: 'title',
        headerName: displayMessage('NOTIFICATIONS_TITLE'),
        valueGetter: (params) => params?.row.title || '',
        width: 220
    },
    {
        field: 'description',
        headerName: displayMessage('NOTIFICATIONS_DESCRIPTION'),
        width: 280,
        valueGetter: (params) => params?.row.description || ''
    },
    {
        field: 'user_ids',
        headerName: displayMessage('RECIPIENTS'),
        flex: 1,
        valueGetter: (params) => {
            const ids = params?.row?.user_ids
            if (!ids || ids.length === 0) return 'Todos os usuários'
            return `${ids.length} usuário(s) específico(s)`
        }
    },
    {
        field: 'sent',
        headerName: 'Push enviado',
        width: 130,
        valueGetter: (params) => params?.row?.sent ? 'Sim' : 'Não'
    },
    {
        field: 'created_by',
        headerName: displayMessage('CREATOR'),
        width: 200,
        valueGetter: (params) => params?.row?.Creator?.full_name || '-'
    },
    {
        field: 'createdAt',
        headerName: displayMessage('CREATION_DATE'),
        valueFormatter: (params) => params.value ? dayjs(params.value)?.format('DD/MM/YYYY HH:mm') : 'N/I',
        width: 180
    },
]
